import Api from '../../../services/Api';
import { ApiResponse } from 'apisauce';
import { IComment, ICommentView, IReport } from '../../../common/sharedTypes';

// types
export enum CommentActionTypes {
  GET_COMMENTS = '@@Comments_SEARCH',
  SAVE_NEW_REPORT_COMMENT = '@@Comments_SAVE_NEW_REPORT_COMMENT',
  SAVE_COMMENT_VIEW = '@@Comments_SAVE_NEW_COMMENT_VIEW',
  GET_REPORT_FOR_COMMENTS = `@@Comments_GET_REPORT_FOR_COMMENTS`,
}

export const setComments = (report: IReport) => (dispatch) => {
  dispatch({
    type: CommentActionTypes.GET_COMMENTS,
    value: report.comments || [],
  });
};

export const setReport = (report: IReport) => (dispatch) => {
  dispatch({
    type: CommentActionTypes.GET_REPORT_FOR_COMMENTS,
    value: report,
  });
};

export const getComments = (url: string) => (dispatch) =>
  new Promise<void>(function (resolve, reject) {
    Api.get(url)
      .then((result: ApiResponse<any>) => {
        dispatch(reduceResults(result.data));
        resolve(result.data);
      })
      .catch(function (ex) {
        console.log(ex);
      })
      .finally(function () {
        resolve();
      });
  });

export const reduceResults = (result: IComment[]) => {
  return {
    type: CommentActionTypes.GET_COMMENTS,
    value: result,
  };
};

export const saveNewComment = (url: string, comment: IComment) => (dispatch) =>
  new Promise<void>(function (resolve, reject) {
    Api.post(url, comment)
      .then((result: ApiResponse<any>) => {
        dispatch(reduceSave(result.data));
        resolve(result.data);
      })
      .catch(function (ex) {
        console.log(ex);
      })
      .finally(function () {
        resolve();
      });
  });

export const reduceSave = (result: IComment) => {
  return {
    type: CommentActionTypes.SAVE_NEW_REPORT_COMMENT,
    value: result,
  };
};

export const saveCommentView = (url: string, commentView: ICommentView) => (
  dispatch
) =>
  new Promise<void>(function (resolve, reject) {
    Api.post(url, commentView)
      .then((result: ApiResponse<any>) => {
        dispatch(reduceSaveCommentView(result.data));
        resolve(result.data);
      })
      .catch(function (ex) {
        console.log(ex);
      })
      .finally(function () {
        resolve();
      });
  });

export const reduceSaveCommentView = (result: IComment) => {
  return {
    type: CommentActionTypes.SAVE_COMMENT_VIEW,
    value: result,
  };
};

export const getReport = (url: string) => (dispatch) =>
  new Promise<void>(function (resolve, reject) {
    Api.get(url)
      .then((result: ApiResponse<any>) => {
        dispatch(reducegetReport(result.data));
        resolve(result.data);
      })
      .catch(function (ex) {
        console.log(ex);
      })
      .finally(function () {
        resolve();
      });
  });

export const reducegetReport = (result: IReport) => {
  return {
    type: CommentActionTypes.GET_REPORT_FOR_COMMENTS,
    value: result,
  };
};
